import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-subscribe",
  "use": "icon-subscribe-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-subscribe\"><path d=\"M13.952 9.39H11.1V6.535a.951.951 0 1 0-1.902 0V9.39H6.344a.951.951 0 1 0 0 1.901h2.853v2.854a.951.951 0 1 0 1.902 0V11.29h2.853a.951.951 0 1 0 0-1.902zM17.755 0a2.533 2.533 0 0 1 2.535 2.535V21.55c0 .977-.56 1.867-1.442 2.288-.543.261-1.186.192-1.707-.11l-6.993-4.08-6.993 4.08c-.52.303-1.164.371-1.707.11A2.535 2.535 0 0 1 .007 21.55V2.535C.007 1.135 1.14 0 2.542 0h15.213z\" fill=\"#FE6135\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol